import React from "react"
import { Row, Col } from "reactstrap"
import ScaleText from "react-scale-text"
import EllipsisText from "react-ellipsis-text"
import { userRole } from "utils"

import customerImage from "../../../assets/images/avatar/avatar-customer.png"
import assistantImage from "../../../assets/images/avatar/avatar-getech.jpg"

const MessageNotification = props => {
  const { role } = props.userInfo
  const { CUSTOMER, CUSTOMER_PURCHASER } = userRole

  const image = (
    <img
      src={
        role === CUSTOMER || role === CUSTOMER_PURCHASER
          ? assistantImage
          : customerImage
      }
      alt="user"
      className="rounded-circle"
      style={{ width: "50px", height: "50px" }}
    />
  )
  const username = (
    <h6 className="font-medium mb-2">
      <ScaleText widthOnly={true} maxFontSize={14}>
        {props.sender}
      </ScaleText>
    </h6>
  )
  const msgText = (
    <h6 className="text-muted">
      <ScaleText widthOnly={true} maxFontSize={14}>
        <EllipsisText text={props.msgText} length={50} />
      </ScaleText>
    </h6>
  )

  return (
    <Row>
      <Col sm={2} className="center-component d-flex">
        <div className="chat-img">{image}</div>
      </Col>
      <Col sm={9}>
        <div className="ml-2 mt-2 mb-2 mr-2">
          {username}
          {msgText}
        </div>
      </Col>
    </Row>
  )
}

export default MessageNotification
